angular.module('content.widgets.SbarWidgetController', [
  'content.widgets.SbarWidgetService'
])

/**
 * The SbarWidgetController manages scope logic and user
 * interaction.
 *
 * @class SbarWidgetController
 * @constructor
 * @module content.widgets.SbarWidgetController
 **/
.controller('SbarWidgetController', [
  '$scope',
  'SbarWidgetService',
  function ($scope, SbarWidgetService) {
    'use strict';

    $scope.setModel = function () {
      return SbarWidgetService.setModel($scope.model);
    };

    $scope.getModel = function () {
      return SbarWidgetService.getModel();
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      SbarWidgetService.setLabel($scope.model.label);
      $scope.model = SbarWidgetService.getModel();
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);
    }

    initialize();
  }
]);
